module.exports = __webpack_public_path__ + "static/media/yoga.84b971ff.jpeg";